import { useEffect, useRef, useState, useCallback } from "react";
import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";

const date = new Date();

const day = date.getDate();
const month = date.getMonth();
const year = date.getFullYear();

export const COLUMNS_DATA = ({ getClickedData }) => [
  {
    id: "selection",
    Header: ({ getToggleAllRowsSelectedProps }) => (
      <>
        <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
      </>
    ),
    Cell: ({ row }) => {
      return (
        <input
          type="checkbox"
          {...row.getToggleRowSelectedProps()}
          onClick={(e) => getClickedData(e, row)}
        />
      );
    },
  },
  {
    Header: "Investigation/Test",
    accessor: "investigation_name",
    disableSortBy: true,
  },
  {
    Header: "Investigation Code",
    accessor: "investigation_code",
    disableSortBy: true,
  },
  {
    Header: "Rate",
    accessor: "investigation_code1",
    disableSortBy: true,
    defaultValue: 100,
  },
  {
    Header: "Discount",
    accessor: "specialization_obj.specialization",
    disableSortBy: true,
    defaultValue: 20,
  },
  {
    Header: "Amount",
    accessor: "clinic_name",
    disableSortBy: true,
  },
  {
    Header: "Is Urgent",
    accessor: "hospital_name",
    disableSortBy: true,
  },
  {
    Header: "Delivery Date",
    accessor: "area_name",
    disableSortBy: true,
  },
  {
    Header: "Standard Rate",
    accessor: "clinic_phone",
    disableSortBy: true,
  },
  {
    Header: "Discount By",
    accessor: "email",
    disableSortBy: true,
  },
];

export const PACKAGE_COLUMNS_DATA = (
  handleBarcodeChange,
  barcodeDataState,
  shouldIncludeBarcodeFlag
) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
    Cell: ({ row }) => row.index + 1,
  },
  {
    Header: "Id",
    accessor: "id",
    disableSortBy: true,
  },
  {
    Header: "Investigation Id",
    accessor: "investigation_id",
    disableSortBy: true,
  },
  {
    Header: "Investigation Name",
    accessor: "investigation_name",
    disableSortBy: true,
  },
  {
    Header: "DD",
    accessor: "delivery_days",
    disableSortBy: true,
  },
  {
    Header: "Barcode",
    accessor: "barcode_obj.barcode_no",
    disableSortBy: true,
    Cell: ({ row }) => {
      const timeoutRef = useRef(null);
      const inputRef = useRef(null);

      const [localValue, setLocalValue] = useState(
        row.original?.barcode_obj?.barcode_no || ""
      );

      useEffect(() => {
        setLocalValue(row.original?.barcode_obj?.barcode_no || "");
      }, [row.original?.barcode_obj?.barcode_no]);

      const debouncedChange = useCallback(
        (newValue, sampleType) => {
          if (timeoutRef.current) clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(() => {
            handleBarcodeChange(newValue, sampleType);
          }, 500);
        },
        [handleBarcodeChange]
      );

      const handleChange = (e) => {
        const newValue = e.target.value
          .replace(/[^a-zA-Z0-9\-_/+]/g, "")
          .toUpperCase();
        setLocalValue(newValue);
        debouncedChange(newValue, row.original.sample_type_obj[0]);
      };

      return (
        <input
          ref={inputRef}
          type="text"
          value={localValue}
          onChange={handleChange}
          style={{ width: "100%", padding: "5px", border: "1px solid #ddd" }}
        />
      );
    },
  },
  {
    Header: "Sample Type",
    accessor: (row) =>
      row.sample_type_obj?.map((item) => item.sample_type).join(", "),
    disableSortBy: true,
    defaultValue: 100,
  },
];

export const OPTIONS = [
  { key: "doctor_name", value: "Doctor Name" },
  { key: "clinic_name", value: "CLinic Name" },
  { key: "hospital_name", value: "Hospital Name" },
  { key: "area_name", value: "Area Name" },
  { key: "clinic_phone", value: "Clinic Phone" },
  { key: "email", value: "Email" },
  { key: "phone_res", value: "Resident Phone" },
  { key: "address", value: "Address" },
  { key: "clinic_address", value: "Clinic Address" },
  { key: "hospital_address", value: "Hospital Address" },
  { key: "hospital_phone", value: "Hospital Phone" },
  { key: "mobile", value: "Mobile" },
  { key: "doctor_username", value: "Username" },
];
export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];

const IS_WORKING_OPTIONS = [
  { key: true, value: "Yes" },
  { key: false, value: "No" },
];
export const FILTER_DEFINATIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];

export const NEW_REGISTRATION_ZONE_CONFIG = () => [
  {
    label: "Zone",
    type: "select",
    name: "zone_id",
    defaultValue: "",
    options: [],
    validations: {
      maxLength: 255,
      required: true,
    },
  },
];

export const NEW_REGISTRATION_FORM_CONFIG = () => [
  {
    label: "Patient Name",
    type: "input-text",
    name: "patient_name",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Age",
    type: "input-text",
    name: "age",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Date Of Birth",
    type: "input-date",
    name: "dob",
    defaultValue: `${year}-${month}-${day}`,
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Gender",
    type: "select",
    name: "gender",
    defaultValue: "Both",
    options: [
      { key: "Both", value: "Both", label: "Both" },
      { key: "Male", value: "Male", label: "Male" },
      { key: "Female", value: "Female", label: "Female" },
    ],
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Address",
    type: "input-text",
    name: "address",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Area",
    type: "select",
    name: "area",
    defaultValue: "",
    options: [],
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "City",
    type: "input-text",
    name: "city",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "State",
    type: "select",
    name: "state",
    defaultValue: "",
    options: [],
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Mobile Number",
    type: "input-text",
    name: "mobile",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Email ID",
    type: "input-text",
    name: "email",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Weight",
    type: "input-text",
    name: "weight",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Height",
    type: "input-text",
    name: "height",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "LMP",
    type: "input-text",
    name: "lmp",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Blood Group",
    type: "input-text",
    name: "blood_group",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Comments",
    type: "input-text",
    name: "comments",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Refer Doctor",
    type: "select",
    name: "refer_doctor_name",
    defaultValue: "",
    options: [],
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Collection Type",
    type: "select",
    name: "collection_type",
    defaultValue: "",
    options: [],
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Franchise",
    type: "select",
    name: "franchise_type",
    defaultValue: "",
    options: [],
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Refer By Hospital",
    type: "input-text",
    name: "refer_by_hospital",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Lab Name",
    type: "input-text",
    name: "lab_name",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Barcode Number",
    type: "input-text",
    name: "barcode_no",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Attach Documnet",
    type: "input-text",
    name: "barcode_no",
    // name: "attach",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Investigation/Test",
    type: "select",
    name: "investigation_name",
    defaultValue: "",
    options: [],
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Test MRP",
    type: "input-text",
    name: "mrp",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Test Discount",
    type: "input-text",
    name: "discount",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Test Rate",
    type: "input-text",
    name: "rate",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Is Urgent?",
    type: "select",
    name: "urgent",
    defaultValue: "",
    options: [
      { key: true, value: true, label: "Yes" },
      { key: false, value: false, label: "No" },
    ],
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Urgent Delivery Time",
    type: "input-text",
    name: "urgent_delivery_time",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Delivery Time",
    type: "input-text",
    name: "delivery_time",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Discount Type",
    type: "input-text",
    name: "discount_type",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Discount Amount",
    type: "input-text",
    name: "discount_amount",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Discount Approved By",
    type: "input-text",
    name: "discount_approved_by",
    defaultValue: 1,
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Discount Percentage",
    type: "input-text",
    name: "discount_percentage",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Discount Reason",
    type: "input-text",
    name: "discount_reason",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Collection Charge",
    type: "input-text",
    name: "collection_charge",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Additional Charge",
    type: "input-text",
    name: "additional_charge",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Amount After Discount",
    type: "input-text",
    name: "amount_after_discount",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Payment Mode",
    type: "select",
    name: "payment_mode",
    defaultValue: "",
    options: [],
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Amount",
    type: "input-text",
    name: "amount",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Cheque/Card Number",
    type: "input-text",
    name: "cheque_or_card_no",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Bank Name",
    type: "input-text",
    name: "bank_name",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Cash Rendering",
    type: "input-text",
    name: "cash_rendering",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Final Amount",
    type: "input-text",
    name: "final_amount",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Balance Amount",
    type: "input-text",
    name: "balance_amount",
    defaultValue: "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
];
